import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    width: 80,
  },
  content: {
    fontSize: 12,
    color: '#777',
  },
  contentLink: {
    fontSize: 12,
    color: '#777',
    textDecoration: 'underline',
  },
  contentDesc3: {
    fontSize: 11,
    color: '#666',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  contentWriter: {
    display: 'inline-block',
    fontWeight: 'bold',
    fontSize: 11,
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main.toString()}10`,
    paddingLeft: 3,
    paddingRight: 3,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
  },
  personIcon: {
    fontSize: 15,
    color: '#666',
    verticalAlign: 'middle',
  },
  crownIcon: {
    display: 'inline-block',
    height: 13,
    verticalAlign: 'middle',
    marginTop: 1,
    marginRight: 2,
  },
}));

export default useStyles;
